<script lang="ts">
  let {
    variant = 'text',
    width,
    height,
    class: className = ''
  }: {
    variant?: 'text' | 'card' | 'stat' | 'circle' | 'block';
    width?: string;
    height?: string;
    class?: string;
  } = $props();

  const style = $derived(
    `${width ? `width: ${width};` : ''}${height ? `height: ${height};` : ''}`
  );
</script>

<div
  class="skeleton {className}"
  data-skeleton
  data-variant={variant}
  style={style}
  aria-hidden="true"
></div>

<style>
  .skeleton {
    position: relative;
    background: var(--color-surface-sunken);
    background-image: linear-gradient(
      90deg,
      var(--color-surface-sunken) 0%,
      var(--color-surface-hover) 50%,
      var(--color-surface-sunken) 100%
    );
    background-size: 200% 100%;
    background-position: 100% 0;
    animation: skeleton-shimmer 1.4s ease-in-out infinite;
  }

  .skeleton[data-variant='text'] {
    height: 12px;
    border-radius: var(--radius-xs);
  }

  .skeleton[data-variant='block'] {
    height: 80px;
    border-radius: var(--radius-md);
  }

  .skeleton[data-variant='card'] {
    height: 120px;
    border-radius: var(--radius-lg);
  }

  .skeleton[data-variant='stat'] {
    height: 44px;
    border-radius: var(--radius-md);
  }

  .skeleton[data-variant='circle'] {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }

  @keyframes skeleton-shimmer {
    0% { background-position: 100% 0; }
    100% { background-position: -100% 0; }
  }
</style>